import React from "react"
import { componentStyles } from "@mallardbay/lib-react-components"

import Box from "~components/shared/todo-lib-react-components/box"
import WidgetCheckoutFlowPackageSelection from "~widget/components/widget-checkout-flow/widget-checkout-flow-package-selection"

export default function WidgetListingDetailsRightColumn() {
    const styles = useStyles()

    return (
        <Box style={styles.root}>
            <WidgetCheckoutFlowPackageSelection />
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            display: { base: "none", md: "flex" },
            width: { base: "100%", lg: "45%" },
            marginLeft: { base: "0", md: "auto" },
            flexDirection: "column",
            gap: "20px",
            maxWidth: "768px",
        },
    })
}
